import { isoZ, z } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

export const outfitterWebRolesZEnum = z.enum([
  'Owner',
  'Impersonator',
  'Employee',
  'ServiceTech',
  'FrontDeskStaff',
  'Manager'
])
export const OutfitterWebRoles = outfitterWebRolesZEnum.Values
export type OutfitterWebRoles = z.infer<typeof outfitterWebRolesZEnum>
export const OutfitterWebRoleOptions = Object.values(OutfitterWebRoles)

export const NotImpersonatorOutfitterWebRoleOptions = [
  outfitterWebRolesZEnum.Values.Owner,
  outfitterWebRolesZEnum.Values.Manager,
  outfitterWebRolesZEnum.Values.FrontDeskStaff,
  outfitterWebRolesZEnum.Values.ServiceTech
]

export const UniversityOfPolarisAccessEnum = z.enum(['NoAccess', 'AccessRequested', 'AccessGranted']).setEnumLabels({
  NoAccess: 'No Access',
  AccessRequested: 'Access Requested',
  AccessGranted: 'Access Granted'
})

export const UniversityOfPolarisAccessOptions = UniversityOfPolarisAccessEnum.options.map((value) => ({
  value,
  label: UniversityOfPolarisAccessEnum.enumLabels[value]
}))

export type UniversityOfPolarisAccessEnum = z.infer<typeof UniversityOfPolarisAccessEnum>

export const EarnedMasterServiceDealerCertificationsEnum = z
  .enum(['OffRoad', 'IndianMotorcycle', 'Slingshot', 'Snowmobile'])
  .setEnumLabels({
    OffRoad: 'Off-Road',
    IndianMotorcycle: 'Indian Motorcycle',
    Slingshot: 'Slingshot',
    Snowmobile: 'Snowmobile'
  })

export const EarnedMasterServiceDealerCertificationsOptions = EarnedMasterServiceDealerCertificationsEnum.options.map(
  (value) => ({
    value,
    label: EarnedMasterServiceDealerCertificationsEnum.enumLabels[value]
  })
)

export type EarnedMasterServiceDealerCertificationsEnum = z.infer<typeof EarnedMasterServiceDealerCertificationsEnum>

export const EmailSubscriptionPreferencesOptions = [
  'dailyReservation',
  'reservationCreateConfirmations',
  'abandonedCart',
  'customerEmailReplies'
] as const
export const EmailSubscriptionPreferences = enumOptionsToObject(EmailSubscriptionPreferencesOptions)
export type EmailSubscriptionPreferencesEnum = keyof typeof EmailSubscriptionPreferences
export const EmailSubscriptionPreferencesLabels = {
  [EmailSubscriptionPreferences.dailyReservation]: 'Daily reservation',
  [EmailSubscriptionPreferences.reservationCreateConfirmations]: 'Reservation create confirmations',
  [EmailSubscriptionPreferences.customerEmailReplies]: 'Customer Email Replies',
  [EmailSubscriptionPreferences.abandonedCart]: 'Abandoned cart'
}

export const smsSubscriptionPreferencesOptions = ['reservationCreateConfirmations'] as const
export const smsSubscriptionPreferences = enumOptionsToObject(smsSubscriptionPreferencesOptions)
export type smsSubscriptionPreferencesEnum = keyof typeof smsSubscriptionPreferences
export const smsSubscriptionPreferencesLabels = {
  [smsSubscriptionPreferences.reservationCreateConfirmations]: 'Reservation create confirmations'
}

export const outfitterUsersModel = z.object({
  id: z.number(),
  outfitterId: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string().nullable(),
  role: outfitterWebRolesZEnum,
  universityOfPolarisAccess: UniversityOfPolarisAccessEnum.nullable(),
  earnedMasterServiceDealerCertifications: EarnedMasterServiceDealerCertificationsEnum.array().nullable(),
  emailSubscriptionPreferences: z.enum(EmailSubscriptionPreferencesOptions).array(),
  smsSubscriptionPreferences: z.enum(smsSubscriptionPreferencesOptions).array(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type outfitterUsersModel = z.infer<typeof outfitterUsersModel>
